<script lang="ts" setup>
import { computed } from 'vue'

import type {
  DialogContentEmits,
  DialogContentProps,
} from '@fondof-ui/components/drawer'
import { useForwardPropsEmits } from 'radix-vue'
import { DrawerContent, DrawerPortal } from 'vaul-vue'

const props = defineProps<DialogContentProps>()
const emits = defineEmits<DialogContentEmits>()

const delegatedProps = computed(() => {
  const { to: _, ...delegatedProps } = props
  return delegatedProps
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <DrawerPortal :to="props.to">
    <slot name="overlay" />
    <DrawerContent
      v-bind="forwarded"
      :class="props.class"
    >
      <slot name="lever" />
      <slot />
    </DrawerContent>
  </DrawerPortal>
</template>
